function canDrag(element) {
    const editable = element.options.editable;
    return editable && editable.drag !== false;
}

export { canDrag };
